import {
  Button,
  Col,
  Flex,
  Image,
  Modal,
  Row,
  Tag,
  Typography,
  Upload,
} from "antd";
import React, { useEffect, useState } from "react";
import { GetCardLayout } from "../../../../../common/getCardLayout";
import styles from "./LoginAuth.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerInfoByIdAction } from "../../../../../../redux/services/customers/customersServices";
import RequiredLabel from "../../../../../common/required-label/RequiredLabel";
import {
  dateObjToDispViewDate,
  downloadUrl,
  formulateAttachmentPreview,
  readImageFileAsync,
} from "../../../../../../utils/utils";
import { routes } from "../../../../../../constants";
import { baseRouteMakerForSuperAdmin } from "../../../../../../constants/routeConsts";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { StatusTag } from "../../../../../common/status-tag";
import { useTranslation } from "react-i18next";

const LoginAuthDetails = () => {

  const {t} = useTranslation();

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const { selectedCustomerId } = useSelector((state) => state.customers);
  const [customerInfoDetails, setCustomerInfoDetails] = useState(null);

  /* module dependencies for attachment - multiple */
  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
  const [previewImageSrc, setPreviewImageSrc] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [multipleAttachmentList, setMultipleAttachmentList] = useState([]);
  /* module dependencies for attachment - multiple */

  /* open image preview for dialog - multiple attachment */
  const handleAttachmentPreview = async (file) => {
    if (file.url && file.name) {
      const formulateAttachment = await formulateAttachmentPreview(
        file,
        file?.name,
        file?.url
      );
      if (!formulateAttachment?.isFileTypeImage) {
        downloadUrl(formulateAttachment?.fileImagePreview);
      } else {
        if (!file.url && !file.preview) {
          file.preview = await readImageFileAsync(file.originFileObj);
        }
        setPreviewImageSrc(file?.url || file?.preview);
        setOpenPreviewDialog(true);
        const tempPreviewTitle =
          file?.name || file?.url?.substring(file?.url?.lastIndexOf("/") + 1);
        setPreviewTitle(tempPreviewTitle);
      }
    }
  };
  /* open image preview for dialog - multiple attachment */

  useEffect(() => {
    /* initial dependencies - Edit */
    if (
      selectedCustomerId &&
      selectedCustomerId !== "" &&
      selectedCustomerId !== null &&
      selectedCustomerId !== undefined
    ) {
      const dataToBeSent = {
        selectedCustomerId,
      };
      dispatch(getCustomerInfoByIdAction(dataToBeSent, setLoading)).then(
        (apiRes) => {
          const response = apiRes;
          setCustomerInfoDetails(response);
          setMultipleAttachmentList(
            response?.documents?.map((element) => ({
              ...element,
              url: element?.documentUrl,
            }))
          );
        }
      );
    }
  }, []);

  return (
    <div className={styles.customerInfoDetailsContainer}>
      <GetCardLayout>
        <Flex vertical gap="2rem">
          <Flex gap="1rem">
            <Button
              type="default"
              shape="circle"
              size="small"
              icon={<ArrowLeftOutlined />}
              onClick={() =>
                navigate(baseRouteMakerForSuperAdmin(routes.LOGIN_AUTH))
              }
            />
            <Typography.Title underline level={2}>
              {t("CommonUtils.doctorAuthInfo")}
            </Typography.Title>
          </Flex>
          <Row gutter={[16, 16]}>
            <Col span={8}>
              <RequiredLabel text={t("CommonUtils.profileImage")} required={false} />
              {customerInfoDetails?.profile_image ? (
                <Image
                  style={{
                    width: "120px",
                    maxWidth: "100%",
                    border: "1px solid lightGray",
                    padding: "5px",
                    borderRadius: "10px",
                  }}
                  src={customerInfoDetails?.profile_image ?? "-"}
                  alt="Profile Image"
                />
              ) : (
                <>-</>
              )}
            </Col>
            <Col span={8}>
              <RequiredLabel text={t("CommonUtils.fullName")} required={false} />
              <div>{`${customerInfoDetails?.first_name ?? ""} ${
                customerInfoDetails?.last_name ?? ""
              }`}</div>
            </Col>
            <Col span={8}>
              <RequiredLabel text={t("appointmentInfo.email")} required={false} />
              <div>{customerInfoDetails?.email ?? ""}</div>
            </Col>
            <Col span={8}>
              <RequiredLabel text={t("appointmentInfo.phoneNumber")} required={false} />
              <div>{`+${customerInfoDetails?.phone?.country_code ?? ""} ${
                customerInfoDetails?.phone?.phone_number ?? ""
              }`}</div>
            </Col>
            <Col span={8}>
              <RequiredLabel text={t("CommonUtils.gender")} required={false} />
              <div>{customerInfoDetails?.gender ?? "-"}</div>
            </Col>
            <Col span={8}>
              <RequiredLabel text={t("CommonUtils.dateOfBirth")} required={false} />
              <div>
                {dateObjToDispViewDate(
                  customerInfoDetails?.date_of_birth,
                  "ddmmyyyy"
                ) ?? "-"}
              </div>
            </Col>
            <Col span={8}>
              <RequiredLabel text={t("CommonUtils.accountStatus")} required={false} />
              <StatusTag status={customerInfoDetails?.status === "active" ? true : false}/>
            </Col>
            <Col span={24}>
              <RequiredLabel text={t("CommonUtils.documents")} required={false} />
              {multipleAttachmentList?.length !== 0 ? (
                <Flex vertical align="center" justify="center">
                  <Upload
                    listType="picture-card"
                    // accept=".pdf"
                    fileList={multipleAttachmentList}
                    onPreview={handleAttachmentPreview}
                    className="uploadContainer"
                  ></Upload>
                  <Modal
                        open={openPreviewDialog}
                        title={previewTitle}
                        footer={null}
                        onCancel={() => setOpenPreviewDialog(false)}
                      >
                        <img style={{ width: "100%" }} src={previewImageSrc} />
                      </Modal>
                </Flex>
              ) : (
                <>-</>
              )}
            </Col>
          </Row>
        </Flex>
      </GetCardLayout>
    </div>
  );
};

export default LoginAuthDetails;
